/// <amd-module name="Tfs/Platform/TfsComponent" />
import { getTFSProject, IProjectData, ITeamData, ITfsPageService } from "Tfs/Platform/Page";
import { IdentityRef } from "VSS/Platform/Contracts/WebApi";
import { IVssComponentContext, IVssComponentProperties, usePageContext, useService, VssComponent } from "VSS/Platform/Layout";
import { IVssPageService } from "VSS/Platform/Page";

export abstract class TfsComponent<P extends IVssComponentProperties = IVssComponentProperties, S = {}, SS = {}> extends VssComponent<P, S, SS> {
    protected projectData: IProjectData | undefined;
    protected currentUser: IdentityRef | undefined;
    protected teamData: ITeamData | undefined;

    constructor(props: P, context: IVssComponentContext) {
        super(props, context);

        this.projectData = getTFSProject(context.pageContext);

        const vssPageService = context.pageContext.getService<IVssPageService>("IVssPageService");
        const pageData = vssPageService.getData();
        this.currentUser = pageData?.user;

        const tfsPageService = context.pageContext.getService<ITfsPageService>("ITfsPageService");
        this.teamData = tfsPageService.getHorizontalNavigationTeamData();
    }
}

export function useTfsProject() {
    const pageContext = usePageContext();
    return getTFSProject(pageContext);
}

export function useTfsCurrentUser(): IdentityRef | undefined {
    const vssPageService = useService<IVssPageService>("IVssPageService");
    const pageData = vssPageService.getData();
    return pageData?.user;
}

export function useTfsTeamData(): ITeamData | undefined {
    const tfsPageService = useService<ITfsPageService>("ITfsPageService");
    return tfsPageService.getHorizontalNavigationTeamData();
}
